<template>
  <div
    id="branding-template-form"
  >
    <h2
      v-if="brandingTemplate.name"
    >
      <router-link
        :to="{
          name: 'branding_template',
          params: {
            brandingTemplateId: brandingTemplateId
          }
        }"
      >{{ brandingTemplate.name }}</router-link>
    </h2>
    <form
      v-on:submit.prevent="submit"
    >
      <div
        class="form-group"
      >
        <label
          for="branding_template_name"
        >
          Name
        </label>
        <input
          type="text"
          name="branding_template[name]"
          id="branding_template_name"
          placeholder="Template Name"
          class="form-control"
          v-model="brandingTemplate.name"
          required
        />
      </div>

      <div
        class="form-group"
      >
        <label
          for="branding_template_template_type"
        >
          Template Type
        </label>
        <select
          name="branding_template[template_type]"
          id="branding_template_template_type"
          class="form-control"
          :selected="brandingTemplate.template_type"
        >
          <option
            value="mailer"
          >
            Mailer
          </option>
        </select>
      </div>

      <div
        class="form-group"
      >
        <label
          for="branding_template_description"
        >
          Description
        </label>
        <textarea
          type="text"
          name="branding_template[description]"
          id="branding_template_description"
          placeholder="Template Description"
          class="form-control"
          v-model="brandingTemplate.description"
        ></textarea>
      </div>

      <div
        class="form-group"
      >
        <label
          for="branding_template_template_content"
        >
          Template Content
        </label>
        <a
          href=""
          v-on:click.prevent="toggleTechDetails"
        >
          Help
        </a>
        <div
          class="alert alert-light"
          v-if="showTechDetails"
        >
          <p>
            Templates use the <cite><a href="https://www.rubyguides.com/2018/11/ruby-erb-haml-slim/">ERB template system</a></cite>. Below are a list of available custom variables:
          </p>

          <dl>
            <dt><code>content</code></dt>
            <dd>
              The content block.
            </dd>
            <dt><code>home_url</code></dt>
            <dd>
              The base url of your site.
            </dd>
            <dt><code>manage_subscription_url</code></dt>
            <dd>
              An subscription management url, if the template is for a newsletter or targeted email.
            </dd>
            <dt><code>unsubscribe_url</code></dt>
            <dd>
              An unsubscribe url, if the template is for a newsletter or targeted email.
            </dd>
          </dl>

          <p>
            Settings can be embedded via <code>Branding</code>. For example:
            <code><%= Branding.get_val('contact_email') %></code>
          </p>
        </div>
        <textarea
          type="text"
          name="branding_template[template_content]"
          id="branding_template_template_content"
          placeholder="Template Content"
          class="form-control"
          v-model="brandingTemplate.template_content"
          required
        ></textarea>
      </div>

      <div
        class="form-check"
      >
        <input
          type="hidden"
          name="branding_template[inactive]"
          value="false"
        />
        <input
          type="checkbox"
          name="branding_template[inactive]"
          class="form-check-input"
          id="branding_template_inactive"
          v-model="brandingTemplate.inactive"
        />
        <label
          for="branding_template_inactive"
        >
          Inactive?
        </label>
      </div>

      <button
        type="submit"
        class="btn btn-primary btn-block"
      >
        {{ formActionLbl }} Template
        <spinner size="small" v-if="base.loading" />
      </button>
    </form>
  </div>
</template>
<script>
import Spinner from 'vue-simple-spinner'

import FlashStore from '@/stores/FlashStore'

import { mapState } from 'vuex'

export default {
  data () {
    return {
      showTechDetails: false
    }
  },

  props: {
    brandingTemplateId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  computed: mapState({
    formAction () {
      return this.brandingTemplateId ? 'update' : 'create'
    },

    formActionLbl () {
      return this.formAction === 'update' ? 'Update' : 'Create'
    },

    base: state => state.base,
    brandingTemplate: state => state.BrandingTemplateModule.branding_template
  }),

  components: {
    'spinner': Spinner
  },

  created () {
    if (this.brandingTemplateId) {
      this.$store.dispatch(
        'BrandingTemplateModule/getTemplate', this.brandingTemplateId
      ).catch(this.$root.processErrors)
    }
  },

  methods: {
    submit (ev) {
      this.$store.dispatch(
        `BrandingTemplateModule/${this.formAction}Template`, {
          formdata: new FormData(ev.target),
          templateId: this.brandingTemplate.id
        }
      ).catch(this.$root.processErrors).then((resp) => {
        if (this.formAction === 'create') {
          this.$router.push({
            name: 'branding_template',
            params: {
              brandingTemplateId: this.brandingTemplate.id
            }
          })
        }

        FlashStore.result(`Template ${this.formAction}d.`)
      })
    },

    toggleTechDetails () {
      this.showTechDetails = this.showTechDetails !== true
    }
  }
}
</script>
<style scoped>
#branding_template_template_content {
  height: 12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/BrandingTemplateForm.vue